import { Controller } from '@hotwired/stimulus';

// Toggles `revealClass` on the element once the user scrolls past a depth.
//
// Fallback trigger for the nav's mobile logo->CTA swap on pages with no hero
// CTA to gate on (blog, compare, most inner pages). Per Travis: reveal based on
// scroll depth (not time), matched roughly to where the homepage hero CTA leaves
// the viewport. Defaults to one viewport height; override with a fixed pixel
// depth via data-scroll-depth-threshold-value="<px>".
export default class extends Controller {
  static values = {
    revealClass: String,
    threshold: Number
  };

  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  get threshold() {
    return this.hasThresholdValue ? this.thresholdValue : window.innerHeight;
  }

  handleScroll() {
    if (!this.hasRevealClassValue) return;
    this.element.classList.toggle(this.revealClassValue, window.scrollY > this.threshold);
  }
}
